'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MEDIA_ALIGNMENT_TYPES = exports.MEDIA_ALIGNMENT_TYPES = {
  start: 'private-media--align-start',
  baseline: 'private-media--align-baseline',
  center: 'private-media--align-middle',
  end: 'private-media--align-bottom',
  stretch: 'private-media--align-stretch'
};

var MEDIA_SPACING = exports.MEDIA_SPACING = {
  none: 'private-media--collapsed',
  'extra-small': 'private-media--spaced-xs',
  small: '',
  medium: 'private-media--spaced-md',
  large: 'private-media--spaced-lg',
  'extra-large': 'private-media--spaced-xl'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/layout/MediaConstants.js
// module id = 1108
// module chunks = 2 3